import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'lib-knowledge-base-lib',
  template: ``,
})
export class KnowledgeBaseLibComponent implements OnInit {

  constructor() { }

  ngOnInit(): void { }

}
